/** @format */

export enum WarrantyButtonState {
	BeforeSkuResolve = 'beforeSkuResolve',
	WarrantyAvailable = 'warrantyAvailable',
	WarrantyNotAvailable = 'warrantyNotAvailable',
	WarrantySelected = 'warrantySelected'
}
